import { useEffect } from "preact/hooks";

import { AnalyticsProvider, TrackPageView } from "../../analytics";
import { useSDKContext } from "../SDKContext";
import { sdkDeleteCard } from "./sdkDeleteCard.api";
import { sdkGetIntentDetails } from "./sdkGetIntentDetails.api";
import { sdkGetIntentMethods } from "./sdkGetIntentMethods.api";
import { sdkGetMethods } from "./sdkGetMethods.api";
import { sdkProceedWith } from "./sdkProceedWith.api";
import { sdkResetSelectedMethod } from "./sdkResetSelectedMethod.api";
import { sdkSubmitCardCvv } from "./sdkSubmitCardCvv.api";
import { sdkSubmitNativeForm } from "./sdkSubmitNativeForm.api";
import { sdkGenerateAccessToken } from "./sdkGenerateAccessToken.api";
import { sdkCreateCardToken } from "./sdkCreateCardToken.api";
import { useHeadlessSDKApiHandler } from "./useSDKApiHandler";
import { sdkSubmitReceipt } from "./sdkSubmitReceipt.api";
import { sdkTokenizeReceipt } from "./sdkTokenizeReceipt.api";
import { sdkApplePaySession } from "./sdkAppleSession.api";
import { sdkGetInstallmentPlans } from "./sdkGetInstallmentPlans.api";
import { sdkSelectInstallmentPlan } from "./sdkSelectInstallmentPlan.api";
import { sdkGetSubscriptionPlans } from "./sdkGetSubscriptionPlans.api";
import { sdkGetSubscriptionPlanGroups } from "./sdkGetSubscriptionPlanGroups.api";
import { sdkSelectSubscriptionPlan } from "./sdkSelectSubscriptionPlan.api";
import { sdkBinLookup } from "./sdkBinLookup.api";
import { sdkBinLookupByReceipt } from "./sdkBinLookupByReceipt";

const HeadlessSDK = () => {
  const { messagingService, isEmbedBySDK } = useSDKContext();
  useHeadlessSDKApiHandler("sdk:getIntentDetails", sdkGetIntentDetails);
  useHeadlessSDKApiHandler("sdk:getIntentMethods", sdkGetIntentMethods);
  useHeadlessSDKApiHandler("sdk:getMethods", sdkGetMethods);
  useHeadlessSDKApiHandler("sdk:proceedWith", sdkProceedWith);
  useHeadlessSDKApiHandler("sdk:binLookup", sdkBinLookup);
  useHeadlessSDKApiHandler(
    "sdk:selectInstallmentPlan",
    sdkSelectInstallmentPlan
  );
  useHeadlessSDKApiHandler(
    "sdk:selectSubscriptionPlan",
    sdkSelectSubscriptionPlan
  );
  useHeadlessSDKApiHandler("sdk:getInstallmentPlans", sdkGetInstallmentPlans);
  useHeadlessSDKApiHandler(
    "sdk:getSubscriptionPlanGroups",
    sdkGetSubscriptionPlanGroups
  );
  useHeadlessSDKApiHandler("sdk:getSubscriptionPlans", sdkGetSubscriptionPlans);
  useHeadlessSDKApiHandler("sdk:resetSelectedMethod", sdkResetSelectedMethod);
  useHeadlessSDKApiHandler("sdk:deleteCard", sdkDeleteCard);
  useHeadlessSDKApiHandler("sdk:generateAccessToken", sdkGenerateAccessToken);
  useHeadlessSDKApiHandler("sdk:createCardToken", sdkCreateCardToken);
  useHeadlessSDKApiHandler("sdk:submitReceipt", sdkSubmitReceipt);
  useHeadlessSDKApiHandler("sdk:tokenizeReceipt", sdkTokenizeReceipt);
  useHeadlessSDKApiHandler("sdk:applePaySession", sdkApplePaySession);
  useHeadlessSDKApiHandler("sdk:submitNativeForm", sdkSubmitNativeForm, {
    disableErrorFormatting: true,
  });
  useHeadlessSDKApiHandler("sdk:submitCardCvv", sdkSubmitCardCvv, {
    disableErrorFormatting: true,
  });
  useHeadlessSDKApiHandler("sdk:binLookupByReceipt", sdkBinLookupByReceipt);

  useEffect(() => {
    if (!isEmbedBySDK) return;
    messagingService.send({ type: "headlessSDK:init" });
  }, [messagingService, isEmbedBySDK]);

  return (
    <AnalyticsProvider module="headless_sdk">
      <TrackPageView page="headless_sdk" />
    </AnalyticsProvider>
  );
};

export default HeadlessSDK;
